export const Logo = ({ size = "text-3xl", className = "" }) => {
  const h = { "text-2xl": "h-7", "text-3xl": "h-9", "text-4xl": "h-11", "text-5xl": "h-14", "text-7xl md:text-8xl": "h-20 md:h-28" }[size] || "h-9";
  return <img src="/logo.png" alt="nini" data-testid="nini-logo" className={`${h} w-auto select-none ${className}`} draggable={false} />;
};
